import { h } from 'preact';
import { getKey, Key, Properties, TravelDates, WidgetTab } from '../../common';
import Selector from '../../common/Selector/Selector';
import { DateFormat, DateText } from '../../i18n/Format';
import { ModalContext } from '../../modal';
import { BookingState, connectStore } from '../../store';
import { WithStyles } from '../../style';
import { isPresent, stopPropagation } from '../../utils';
import DateModal from './DateModal/DateModal';
import { FinText } from '../../i18n';
import { ScreenResolution } from '../../common/hooks/ScreenResolution';

export enum TravelDateType {
  DEPARTURE = 'departure',
  RETURN = 'return',
}

export interface DateSelectorProps extends Properties {
  type: TravelDateType;
  isAward?: boolean;
}

interface StoreProps {
  travelDates: TravelDates;
  departureDateEnabled: boolean;
  returnDateEnabled: boolean;
  onAmTab: boolean;
  locale: string;
  enableCompactWidget: boolean;
}

type EffectiveProps = DateSelectorProps & StoreProps & WithStyles;

const mapStateToProps = ({
  selection: { travelDates },
  amState: {
    amSelection: { amTravelDates },
  },
  ux: { departureDateEnabled, returnDateEnabled, i18n },
  currentTab,
  enableCompactWidget,
}: BookingState): StoreProps => ({
  travelDates: currentTab === WidgetTab.AM ? amTravelDates : travelDates,
  departureDateEnabled,
  returnDateEnabled,
  onAmTab: currentTab === WidgetTab.AM,
  locale: i18n.locale,
  enableCompactWidget,
});

export const DateSelector = connectStore({ mapStateToProps })((props: EffectiveProps, context: ModalContext) => {
  const { travelDates, type, onAmTab, isAward, departureDateEnabled, returnDateEnabled, locale, enableCompactWidget } =
    props;
  const date: string = type === TravelDateType.DEPARTURE ? travelDates.departureDate : travelDates.returnDate;
  const enabled = onAmTab || (type === TravelDateType.DEPARTURE ? departureDateEnabled : returnDateEnabled);

  const [clientType] = ScreenResolution();

  const openModal = (e: Event): void => {
    stopPropagation(e);
    if (!onAmTab && !enabled) {
      return;
    }

    context.modal.showModal(<DateModal isAward={isAward} locale={locale} clientType={clientType} />);
  };

  const handleKeyUp = (e: KeyboardEvent): void => {
    const key: Key = getKey(e);
    if (key === Key.ENTER || key === Key.SPACE) {
      openModal(e);
    }
  };

  return (
    <Selector class={props.class} onClick={openModal} onKeyUp={handleKeyUp} disabled={!enabled}>
      <div class="grey-600-text font-body-1 regular-type">
        <FinText id={`dateSelector.${type}.title`} />
      </div>
      {isPresent(date) && (
        <div class="nordic-blue-900-text medium-type font-heading-5">
          <DateText value={date} format={enableCompactWidget ? DateFormat.DATE_AND_MONTH_FULL : DateFormat.DATE} />
        </div>
      )}
      {isPresent(date) && !enableCompactWidget && (
        <div class="nordic-blue-900-text regular-type font-body-1">
          <DateText value={date} format={DateFormat.WEEKDAY} />
        </div>
      )}
    </Selector>
  );
});
